import type { WindowState } from '@/stores/windowStore';
import { useWindowStore } from '@/stores/windowStore';
import { getAppById } from '@/config/desktopApps';

interface WindowButtonProps {
  window: WindowState;
  isActive: boolean;
}

export function WindowButton({ window, isActive }: WindowButtonProps) {
  const { restoreWindow, focusWindow } = useWindowStore();
  const app = getAppById(window.appId);

  if (!app) return null;

  const handleClick = () => {
    if (window.isMinimized) {
      restoreWindow(window.id);
    } else {
      focusWindow(window.id);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`win98-button px-3 py-1 flex items-center gap-2 text-xs font-mono text-black max-w-[200px] truncate ${
        isActive && !window.isMinimized ? 'taskbar-button-active' : ''
      }`}
    >
      <span>{app.icon}</span>
      <span className="truncate">{window.title}</span>
    </button>
  );
}
